




























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';

@Component({
  name: 'Myreferrals',
  components: {
  }
})
export default class Myreferrals extends Vue {
    get isLoggedIn() {
      return vxm.users.isLoggedIn;
    }
}
